import TrackingHistoryAPI from '@/app/apis/main/telstra/tracking-history/tracking-history.js';

export default {
	/**
	 * @param {*} trackingDetails contains tracking details
	 * @returns {object} tracking history details
	 */
	async getTrackingDetails(trackingDetails) {
		return TrackingHistoryAPI.getTrackingDetails(trackingDetails);
	},

	/**
	 * @param {*} petId
	 * @returns no content
	 */
	async connectPetTracking(petId) {
		return TrackingHistoryAPI.connectPetTracking(petId);
	},

	/**
	 * @param {*} petId
	 * @return no content
	 */
	async disconnectPetTracking(petId) {
		return TrackingHistoryAPI.disconnectPetTracking(petId);
	},

	/**
	 * @param {*} petId, serialNumber
	 * @return no content
	 */
	async putSerialNumberTracking(petId, serialNumber) {
		return TrackingHistoryAPI.putSerialNumberTracking(petId, serialNumber);
	},

	/**
	 * @param {*} petId, serialNumber
	 * @return no content
	 */
	async deleteSerialNumberTracking(petId, serialNumber) {
		return TrackingHistoryAPI.deleteSerialNumberTracking(petId, serialNumber);
	}
	
};
